import React from "react"
import {Card, Container, Row, Col} from 'react-bootstrap' 
import DraggableScroll from '../../DraggableScroll'

/*
  This class is not generally used and will likely be deleted soon or revamped

  Shows some recent stats that the counters did but doesn't diplay enough info to matter
*/
export default class CustomCountingJobsCard extends React.Component {

  constructor(props) {
    super(props)

    this.feedlot_id = props.feedlot_id
    this.is_admin = props.is_admin || false
    
    this.state = {
      status: "Loading",
      page: null,
      total_pages: null,
      jobs: []
    }

    this.searchInput = React.createRef()
    //this.feedlotListener = this.subscribe()

    this.currentWidth = window.innerWidth
    window.addEventListener("resize", () => {
      var previousWidth = this.currentWidth
      this.currentWidth = window.innerWidth
      if (this.currentWidth <= lg_bp && previousWidth > lg_bp) {
        this.forceUpdate()
      }
      if(this.currentWidth > lg_bp && previousWidth <= lg_bp) {
        this.forceUpdate()
      }
    });
  }

  componentDidMount() {
    this.getJobs(0)
  }

  render () {
    try {
      const is_admin = this.is_admin
      const total_pages = this.state.total_pages

      var condensed = this.currentWidth <= lg_bp

      return (
        <Card id="completed-jobs">
          <Card.Header>
            <Container fluid className="p-0">
              <Row className="justify-content-between">
                <Col xs="auto" className="p-0">
                  <Card.Title>
                    Custom Jobs
                  </Card.Title>
                  <a className="btn btn-primary ml-2 fas fa-plus" 
                    href={Routes.new_custom_counting_job_path(this.feedlot_id)}
                    data-tip data-for="order-job"
                    style={{verticalAlign: "bottom", fontSize: "1em"}}/>
                  <ReactTooltip id='order-job' effect='solid' 
                     

                    textColor="black">
                    <span>Order Job</span>
                  </ReactTooltip>
                </Col>
                <Col xs="auto" className="p-0">
                  <div className="input-group">
                    <input ref={this.searchInput} type="text" className="form-control card-search-input" placeholder="Search" onKeyDown={(e) => {e.key === "Enter" && this.getJobs(0)}}/>
                    <div className="input-group-append"> 
                      <button className="input-group-text btn btn-primary" onClick={() => this.getJobs(0)}>
                        <i className="fas fa-search"></i>
                      </button>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Card.Header>
          <Card.Body>
            {this.state.jobs.length == 0 && 
              <div className="mt-2 text-center">
                <b>Custom Jobs that you can freely upload and count manually will be displayed here</b>
              </div>
            }
            {this.state.jobs.length > 0 && 
              <React.Fragment>
                {condensed == false && 
                  <table className="component-table">
                    <thead>
                      <tr>
                        <td>
                          Name
                        </td>
                        <td>
                          # of Images
                        </td>
                        <td>
                          Count
                        </td>
                        <td>
                          Created At
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.jobs.map((job,i) => 
                        <CustomCountingJobObject
                          key={job.id}
                          is_admin={is_admin}
                          job={job}
                          condensed={condensed}/>
                      )}
                    </tbody>
                  </table>  
                }
                {condensed == true && this.state.jobs.map((job,i) => 
                  <CustomCountingJobObject
                    key={job.id}
                    is_admin={is_admin}
                    job={job}
                    condensed={condensed}/>
                )}
              </React.Fragment>
            }
          </Card.Body>
          {total_pages != null && total_pages > 1 && 
            <Card.Footer className="pagination-section">
              <nav>
                <DraggableScroll>
                  <ul className="pagination m-0 pages-footer">
                    {[...Array(total_pages)].map((val, i) =>
                      <li className="page-item" key={i}><button className={"page-link" + (this.state.page == i ? " page-selected" : "")} onClick={() => this.getJobs(i)}>{i+1}</button></li>
                    )}
                  </ul>
                </DraggableScroll>
              </nav>
            </Card.Footer>
          }
        </Card>
      )
    } catch (error) {
      console.log(error)
      Sentry.captureException(error)
      return null
    }
  }

  /*subscribe() {
    var _this = this
    return App.cable.subscriptions.create(
      {
        channel: "DashboardChannels::CustomCountingJobsComponentChannel",
        feedlot_id: this.feedlot_id
      },
      {  
        connected() {
          _this.getJobs(0)
        },

        received(data) {
          if (data.jobs != null) {
            _this.setState({
              status: "Ok",
              page: data.page,
              total_pages: data.total_pages,
              jobs: data.jobs
            })
          } else if (data.job != null) {
            _this.updateJob(data.job)
          } else if (data.message == "job_added") {
            _this.getJob(data.job_id)
          } else if (data.message == "job_removed") {
            _this.removeJob(data.job_id)
          } else if (data.message == "job_updated") {
            if (_this.state.jobs.filter((job) => job.id == data.job_id).length > 0) {
              _this.getJob(data.job_id)
            }
          }
        }
      }
    )
  }*/

  getJobs(page) {
    page = page || 0
    let search = this.searchInput?.current?.value || null
    var _this = this
    $.ajax({
      url: Routes.custom_counting_jobs_feedlot_path(this.feedlot_id),
      type: "GET",
      data: { page: page, search: search },
      dataType: 'json',
      success: (data) => {
        if (data.jobs != null) {
          _this.setState({
            status: "Ok",
            page: data.page,
            total_pages: data.total_pages,
            jobs: data.jobs
          })
        } else {
          _this.setState({
            status: "Failed"
          })
        }
      },
      error: () => {
        _this.setState({
          status: "Failed"
        })
      }
    })
  }

  /*getJob(job_id) {
    this.feedlotListener.perform("get_job", {id: job_id})
  }*/

  removeJob(job_id) {
    this.setState(function(state, props) {
      return {
        jobs: state.jobs.filter((job) => job.id != job_id)
      }
    })
  }

  updateJob(job_to_update) {
    this.setState(function(state, props) {
      var jobs = state.jobs
      var index = jobs.findIndex((job) => job.id == job_to_update.id)
      if(index == -1) {
        jobs = [job_to_update, ...jobs]
      } else {
        jobs[index] = job_to_update
      }
      
      return {
        jobs: jobs
      }
    })
  }
}

class CustomCountingJobObject extends React.Component {

  constructor(props) {
    super(props);

    // static data
    this.is_admin = props.is_admin
    this.condensed = props.condensed

    // callbacks to parent
    this.removeJob = () => {props.removeJob()}
    
    this.state = {
      job: props.job,
    }
  }

  // when pen is updated, update the state
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.job != this.props.job) {
      this.setState({
        job: nextProps.job
      })
      return true
    }
    if (nextProps.condensed != this.condensed) {
      this.condensed = nextProps.condensed
      return true
    }
    
    return false
  }

  render () {
    try {
      const is_admin = this.is_admin
      const job = this.state.job
      if(job == null) {
        return null
      }

      const job_path = Routes.custom_counting_job_path(job.id)

      if (this.condensed) { // mobile view
        return (
          <Container fluid className="condensed" style={{position: "relative"}}>
            <Row className="justify-content-between text-light condensed-header">
              <Col>
                <a className="txt-lg link-light nowrap" href={job_path}>
                  {job.name || "Undefined"}
                </a>
              </Col>
              <Col xs="auto" className="mr-3 nowrap">
                <div className="txt-lg">
                  {job.finished_at || ""}
                </div>
              </Col>
            </Row>
            <Row className="justify-content-between" style={{flexWrap: "nowrap", overflowX: "auto"}}>
              <Col>
                <table>
                  <tbody>
                    <tr>
                      <td className="pr-2 text-right">
                        # of Images:
                      </td>
                      <td className="pr-2 text-center">
                        {job.pen_count}
                      </td>
                    </tr>
                    <tr>
                      <td className="pr-2 text-right">
                        Count:
                      </td>
                      <td className="pr-2 text-center">
                        {job.count}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col>
                <table>
                  <tbody>
                    <tr>
                      <td className="pr-2 text-right">
                        Created At:
                      </td>
                      <td className="pr-2 text-center">
                        {job.created_at}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </Container>
        )
      } else {
        return (
          <tr>
            <td> {/* Name */}
              <a style={{width: "100%"}} href={job_path}>
                {job.name || "Undefined"}
              </a>
            </td>
  
            <td> {/* Number of Images */}
              {job.pen_count}
            </td>
  
            <td> {/* HC Count */}
              {job.count}
            </td>
            <td> {/* Created At */}
              {job.created_at}
            </td>
          </tr>
        )
      }
    } catch (error) {
      console.log(error)
      Sentry.captureException(error)
      return null
    }
  }
}